import { CompareOrder } from '@dte/otw-utils-core/src/objects/compare/CompareOrder';

import type { DateRepresentation } from '../DateRepresentation';
import { compareLatest } from './compareLatest';

/**
 * Return true if dateA is after dateB
 *
 * @param comesAfter
 * @param compareAgainst
 * @returns
 */
export function isAfter(
	comesAfter: DateRepresentation,
	compareAgainst: DateRepresentation,
	handleUndefined: CompareOrder = CompareOrder.Before,
): boolean {
	return compareLatest(comesAfter, compareAgainst, handleUndefined) === CompareOrder.Before;
}
